<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">

        <template #title>
            <a-page-header style="padding: 0;" title="供货商评估" sub-title="仅可行配方参与评估" />
        </template>

        <div class="drawer-box" style="width: 100%;height: 100%">
            <section style="margin-bottom: 1em;">
                <h4>
                    <b>原料设置</b>
                </h4>
                <a-button style="margin-bottom: 1em;" @click="onTemplateImportClick">模板导入</a-button>
                <a-table :columns="rawTableColumns" :data-source="rawTableData" :loading="rawTableLoading" bordered>
                    <template slot="supplierName" slot-scope="text, record">
                        <div v-if="!record.edit"
                            style="cursor: pointer;width:100%;height:100%;"
                            @click="editSupplierName(record)">
                            <a-spin :spinning="record.saving === true" size="small" class="spinning-block">
                                <span>{{ record.supplierName }}</span>
                            </a-spin>
                        </div>
                        <a-input v-else auto-focus v-model="record.supplierName" @blur="onSupplierNameInputBlur(record)"
                            @pressEnter="onSupplierNameInputBlur(record)" />
                    </template>
                    <cell-editor slot="rawPrice" slot-scope="text, record" :len="3" :item="record" name="rawPrice"
                        @blur="target => rawTableItemUpdate(target, record.id)" :text="text"
                        :actions="rawTableItemUpdateSave" />
                    <template slot="options" slot-scope="text, record">
                        <a @click="onIndicatorMaintainClick(record)">指标维护</a>
                        <a-divider type="vertical" />
                        <a style="color: red;" @click="onDeleteClick(record.id)">删除</a>
                    </template>
                </a-table>
            </section>

            <section>
                <h4>
                    <b>评估设置</b>
                </h4>
                <div style="background-color: #f2f2f2;padding: .5em;border-radius: 5px;">
                    <div style="font-weight: bold;color: #333;"> 价值原料评估 </div>
                    <label>将供货商原料的评估价格和指标带入任务中的可行配方，评估原料用量及配方成本的变化。</label>
                </div>
                <a-button type="primary" style="margin: 1em 0;" @click="onConfirmEvalClick">确认评估</a-button>
            </section>

            <section class="section-table">
                <h4> <b>评估结果</b> </h4>
                <div style="margin-bottom: 1em;">
                    <a-button type="primary" :disabled="tableData.length == 0"
                        @click="onClearBtnClick">清空评估结果</a-button>
                    <a-button style="margin-left: 2em;" :disabled="tableData.length == 0"
                        @click="onExportBtnClick">导出报表</a-button>
                </div>
                <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" bordered
                    :showHeader="false"></a-table>
                <!-- <div v-for="table, index in tableData" :key="index" style="margin-bottom: 1em;">
                    <a-table :columns="tableColumns" :loading="tableLoading"
                        :data-source="tableData[index].formulaTaskRawRespList" row-key="nutritionId" bordered
                        :pagination="false" :showHeader="index == 0">
                    </a-table>
                </div> -->
            </section>
        </div>

        <!-- 模板导入弹窗 -->
        <a-modal :visible="templateImportModalVisible" title="模板导入" class="template-import-modal" @ok="onConfirmClick"
            @cancel="onCancelClick" :confirm-loading="confirmBtnLoading" okText='确定' cancelText='取消' destroyOnClose
            :maskClosable="false" width="700px">
            <a-row class="step-row">
                <a-col :span="4">
                    <span class="step-col">第一步：</span>
                </a-col>
                <a-col :span="20">
                    <span>下载模型模板，<a @click="onTemplateDownloadClick">点击下载模板</a></span>
                    <a-icon type="loading" v-if="templateDownLoading" />
                </a-col>
            </a-row>

            <a-row class="step-row">
                <a-col :span="4">
                    <span class="step-col">第二步：</span>
                </a-col>
                <a-col :span="20">
                    <span>将需要更新的数据填写到Excel模板中（<a @click="onTemplateTipsClick">点击查看填写注意事项</a>）</span>
                </a-col>
            </a-row>

            <a-row class="step-row">
                <a-col :span="4">
                    <span class="step-col">第三步：</span>
                </a-col>
                <a-col :span="20">
                    <span>上传填写完成的Excel模板</span>
                </a-col>
            </a-row>

            <a-row class="step-row">
                <a-col :span="4">
                    <span class="step-col">模板上传：</span>
                </a-col>
                <a-col :span="20">
                    <a-upload name="file" :action="uploadUrl" :headers="headers" @change="onUploadChange"
                        :remove="onUploadRemoveFile" :file-list="fileList" :before-upload="beforeUpload">
                        <a-button>上传模板<a-icon type="upload" /></a-button>
                    </a-upload>
                </a-col>
            </a-row>

            <a-row class="step-row">
                <a-col :span="4">
                </a-col>
                <a-col :span="20">
                    <span style="color: #c3c3c3;">支持扩展名：.xlsx</span>
                </a-col>
            </a-row>
        </a-modal>

        <!-- 指标维护抽屉 -->
        <ind-maintain-drawer :visible="indicatorMaintainDrawerVisible" :title="indicatorMaintainTitle" :task-id="taskId"
            :id="indicatorMaintainId" :raw-id="indicatorMaintainRawId" @close="onIndicatorMaintainClose" />

        <!-- 消息弹窗 -->
        <msg-modal :visible="msgVisible" :configData='configData' @closeMsg="closeMsg" />

        <!-- 评估进度弹窗 -->
        <a-modal :visible="progressModalVisible" title="" :footer="null" :closable="false" class="eval-progress-modal">
            <div class="eval-progress-container">
                <div class="eval-status">
                    <a-spin :spinning="true" size="large">
                        <span>评估中，请稍候...</span>
                    </a-spin>
                </div>
                <a-progress style="margin: 1em 0;" type="line" :percent="evalProgress" />
                <div class="eval-info">
                    <span v-show="totalCalculatedTimes">已计算{{ calculatedTimes }}次，共计{{ totalCalculatedTimes }}次</span>
                    <div v-show="!totalCalculatedTimes" class="eval-loading-tip">
                        <a-icon type="loading" />
                        <span>正在进行配方优化计算...</span>
                    </div>
                </div>
                <div class="eval-progress-footer">
                    <a-button type="default" @click="onTempCloseEvalClick">暂时关闭评估窗口</a-button>
                </div>
            </div>
        </a-modal>
    </a-drawer>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue';
import { exportExcel } from "@/Utils/excel/Export2Excel";
// import { formulaMixins } from '../unitls';
import { baseUrl } from '@/Utils/url.js';
import MsgModal from '../modal/MsgModal.vue';
import IndMaintainDrawer from './IndMaintainDrawer.vue';

const rawTableColumns = [
    {
        title: "原料名称",
        align: 'center',
        dataIndex: "rawName",
        minWidth: 120,
    },
    {
        title: "原料代码",
        align: 'center',
        dataIndex: "rawCode",
        width: 120,
    },
    {
        title: "供货商",
        align: 'center',
        dataIndex: "supplierName",
        width: 120,
        scopedSlots: { customRender: 'supplierName' },
        customCell: () => {
            return {
                style: {
                    backgroundColor: '#56ccf21f'
                }
            };
        },
    },
    {
        title: "价格(元/吨)",
        align: 'center',
        dataIndex: "rawPrice",
        width: 120,
        scopedSlots: { customRender: 'rawPrice' },
    },
    {
        title: "操作",
        align: 'center',
        dataIndex: "rawId",
        width: 120,
        scopedSlots: { customRender: 'options' },
    },
];

const tableColumns = [
    {
        title: "工厂",
        align: 'center',
        dataIndex: "factoryName",
        width: 120,
    },
    {
        title: "原料名称",
        align: 'center',
        dataIndex: "rawName",
        minWidth: 120,
    },
    {
        title: "供货商",
        align: 'center',
        dataIndex: "supplierName",
        width: 120,
    },
    {
        title: "排名",
        align: 'center',
        dataIndex: "rank",
        width: 80,
    },
    {
        title: "价值(元/吨)",
        align: 'center',
        dataIndex: "valuePrice",
        width: 100,
    },
    {
        title: "价格(元/吨)",
        align: 'center',
        dataIndex: "rawPrice",
        width: 120,
    },
    {
        title: "使用量(吨)",
        align: 'center',
        dataIndex: "usageAmount",
        width: 100,
    },
    {
        title: "总成本(元)",
        align: 'center',
        dataIndex: "totalCost",
        width: 100,
    },
    {
        title: "平均成本(元)",
        align: 'center',
        dataIndex: "avgCost",
        width: 110,
    },
];

export default {
    // mixins: [formulaMixins],
    components: { MsgModal, IndMaintainDrawer, CellEditor },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        taskId: {
            type: String,
            default: ''
        },
        taskName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            templateImportModalVisible: false,
            templateDownLoading: false,
            headers: {
                Authorization: 'Basic bmhmY2xvdWQ6bmhmY2xvdWRfS3FOUUxUZGFWOTdhbExvMQ==',
                'iot-Auth': `bearer ${window.localStorage.getItem('accessToken')}`
            },
            fileList: [],
            uploadUrl: `${baseUrl}nhf-app/supplierraw/downloadSupplierRawTemplateImport`,
            confirmBtnLoading: false,
            msgVisible: false,
            configData: {
                status: '',
                msg: []
            },

            rawTableLoading: false,
            rawTableColumns,
            rawTableData: [],
            indicatorMaintainId: '',
            indicatorMaintainRawId: '',
            indicatorMaintainTitle: '',
            indicatorMaintainDrawerVisible: false,

            progressModalVisible: false,
            evalProgress: 0,
            totalCalculatedTimes: 0,
            calculatedTimes: 0,
            evalTimer: null,

            tableColumns,
            tableData: [],
            tableLoading: false,
            scrollX: 1220,
            drawerWidth: 1000,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },

        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.getRawTableData();
                // 如果评估仍在进行中，继续显示进度弹窗
                if (this.evalTimer) {
                    this.progressModalVisible = true;
                } else {
                    // 检查是否有正在进行的评估
                    this.checkEvalStatus();
                }
            } else {
                // 关闭抽屉时，如果评估还在进行中，不清除定时器
                // 只关闭弹窗，保留定时器继续轮询
                this.progressModalVisible = false;
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1000) {
            this.drawerWidth = _width;
            this.scrollX = _width - 80;
        }
    },
    methods: {
        onTemplateImportClick() {
            this.templateImportModalVisible = true;
        },
        async onTemplateDownloadClick() {
            this.templateDownLoading = true;
            await this.$fileDownload('/nhf-app/supplierraw/downloadSupplierRawTemplate', { "taskId": this.taskId }).catch(
                (e) => {
                    e.message && this.$message.error(e.message);
                }
            );
            this.templateDownLoading = false;
        },
        onTemplateTipsClick() {
            window.open('https://newhope1982.feishu.cn/sheets/LvwcsSm8mhQl2iteFwEcv5hBnH6?from=from_copylink');
        },
        onUploadChange(res) {
            let { file, fileList } = res || {};
            let { response } = file || {};
            this.showMsg(response, fileList);
        },
        onUploadRemoveFile() {
            this.fileList = [];
        },
        beforeUpload(file) {
            this.fileList = [file];
            return false;
        },
        async onConfirmClick() {
            if (this.fileList.length === 0) {
                this.$message.warning('请选择上传模板');
                return;
            }
            this.confirmBtnLoading = true;
            const formData = new FormData();
            this.fileList.forEach(file => {
                formData.append('file', file);
            });
            formData.append('taskId', this.taskId);

            try {
                let res = await this.$post(this.uploadUrl, formData);
                if (res.success) {
                    this.onCancelClick();
                    this.getRawTableData();
                }
                this.confirmBtnLoading = false;
                this.showMsg(res, this.fileList);
            } catch (error) {
                this.confirmBtnLoading = false;
                this.$message.error('导入失败');
            }
        },
        onCancelClick() {
            this.fileList = [];
            this.templateImportModalVisible = false;
        },
        showMsg(response, fileList) {
            if (response) {
                let { data, success } = response || {};
                let { msg, allSuccess } = data || {};
                if (success) {
                    if (allSuccess) {
                        this.configData = {
                            status: 'success',
                            title: <p style={{ 'font-size': '16px', color: '', 'font-weight': 'bold' }}><a-icon style={{ 'font-size': '14px', color: '#52c41b', 'margin-right': '10px' }} type="check-circle" />提交成功</p>,
                            content: ['原料数据导入成功，关闭弹窗即可查看。']
                        };
                    } else {
                        this.configData = {
                            status: 'warning',
                            content: msg,
                            title: <p style={{ 'font-size': '14px', color: '', 'font-weight': 'bold' }}><a-icon style={{ 'font-size': '14px', color: '#faad14', 'margin-right': '10px' }} type="info-circle" />部分原料导入失败，请修改后再上传</p>,
                        };
                    }
                } else {
                    this.configData = {
                        status: 'error',
                        title: <p style={{ 'font-size': '14px', color: '', 'font-weight': 'bold' }}><a-icon type="close-circle" style={{ 'font-size': '14px', color: '#f5222d', 'margin-right': '10px' }} />导入失败</p>,
                        content: ['由于网络等原因无法导入，请稍后尝试！'],
                    };
                }
                if (fileList.length > 0) this.msgVisible = true;
            }
        },
        async closeMsg(type) {
            this.msgVisible = false;
            if (type) {
                this.btnLoading = true;
                const formData = new FormData();
                this.fileList.forEach(file => {
                    formData.append('file', file);
                });
                formData.append('factoryId', window.localStorage.getItem('factoryId'));
                let res = await this.$post(this.url, formData);
                this.btnLoading = false;
                this.showMsg(res, this.fileList);
            } else {
                this.$emit('closeExport', 'refresh');
            }
        },
        async getRawTableData() {
            this.rawTableLoading = true;
            const res = await this.$get('/nhf-app/supplierraw/list', {
                "taskId": this.taskId,
                "current": 1,
                "size": 1000
            });

            if (res.success) {
                this.rawTableData = res.data.records;
            }
            this.rawTableLoading = false;
        },
        editSupplierName(record) {
            if (record.saving) {
                return;
            }
            record.edit = true;
            record.saving = false;
            this.rawTableItemUpdate(record, record.id);
        },
        async onSupplierNameInputBlur(record) {
            record.edit = false;
            record.saving = true;
            this.rawTableItemUpdate(record, record.id);
            await this.rawTableItemUpdateSave(record);
            record.saving = false;
            this.rawTableItemUpdate(record, record.id);
        },
        rawTableItemUpdate(item, id) {
            const list = [...this.rawTableData];
            const targets = list.filter(item => id === item.id)[0];
            if (targets) {
                Object.assign(targets, item);
                this.rawTableData = list;
            }
        },
        rawTableItemUpdateSave(item) {
            const data = {
                "id": item.id,
                "rawPrice": item.rawPrice,
                "supplierName": item.supplierName
            };
            return this.$post('/nhf-app/supplierraw/updateSupplierRaw', data);
        },
        onIndicatorMaintainClick(record) {
            this.indicatorMaintainId = record.id;
            this.indicatorMaintainRawId = record.rawId;
            this.indicatorMaintainTitle = record.rawName;
            this.indicatorMaintainDrawerVisible = true;
        },
        onIndicatorMaintainClose() {
            this.indicatorMaintainDrawerVisible = false;
        },
        async onDeleteClick(id) {
            const res = await this.$post('/nhf-app/supplierraw/delBatchSupplierRaw?ids=' + id);
            if (res.success) {
                this.$message.success('删除成功');
                this.getRawTableData();
            }
        },

        async onConfirmEvalClick() {
            // 检查是否有原料数据
            if (!this.rawTableData || this.rawTableData.length === 0) {
                this.$message.warning('请先添加原料数据');
                return;
            }

            // · 原料设置中【供货商】是否有空值？是，toast提示：需完善供货商信息；
            const isSupplierNameEmpty = this.rawTableData.some(item => !item.supplierName || item.supplierName.trim() === '');
            if (isSupplierNameEmpty) {
                this.$message.warning('需完善供货商信息');
                return;
            }

            // · 原料设置中【供货商】是否相同？是，toast提示：需修改相同供货商名称；
            const supplierNames = this.rawTableData.map(item => item.supplierName);
            const uniqueSupplierNames = new Set(supplierNames);
            if (uniqueSupplierNames.size < supplierNames.length) {
                this.$message.warning('需修改相同供货商名称');
                return;
            }

            // · 原料设置中【价格(元 / 吨)】是否有空值？是，toast提示：需填写供货商原料价格；
            const isRawPriceEmpty = this.rawTableData.some(item => item.rawPrice === null || item.rawPrice === undefined || item.rawPrice === '');
            if (isRawPriceEmpty) {
                this.$message.warning('需填写供货商原料价格');
                return;
            }

            // · 原料设置中【原料代码】是否相同？否，toast提示：存在多个原料代码请修改；
            const rawCodes = this.rawTableData.map(item => item.rawCode);
            const uniqueRawCodes = new Set(rawCodes);
            if (uniqueRawCodes.size > 1) {
                this.$message.warning('存在多个原料代码请修改');
                return;
            }

            const res = await this.$get('/nhf-app/formulaRemoteCal/asyncSpeedSupplierRawLinearByOpt', {
                algorithmType: 4,
                optimizationType: 1,
                taskId: this.taskId
            });

            if (res.success) {
                this.getEvalProgress();
            }
        },
        getEvalProgress() {
            this.progressModalVisible = true;
            // 如果已有定时器，先清除
            if (this.evalTimer) {
                clearInterval(this.evalTimer);
            }
            this.evalTimer = setInterval(() => {
                const params = { "taskId": this.taskId };
                this.$get('/nhf-app/formulaRemoteCallback/getSupplierEvaluationProgress', params).then(res => {
                    if (res.success) {
                        this.evalProgress = res.data.progressPer * 100;
                        if (this.evalProgress > 0) {
                            this.evalProgress = Number(this.evalProgress.toFixed(1));
                        }
                        this.totalCalculatedTimes = res.data.totalCalculatedTimes;
                        this.calculatedTimes = res.data.calculatedTimes ? res.data.calculatedTimes : 0;
                        if (res.data.status == 16) {
                            this.stopEvalTimer();
                            this.progressModalVisible = false;
                            setTimeout(() => {
                                this.getEvalResultData();
                                this.$nextTick(() => {
                                    this.calculatedTimes = 0;
                                    this.totalCalculatedTimes = 0;
                                    this.evalProgress = 0;
                                });
                            }, 500);
                        }
                    }
                });
            }, 1000);
        },
        // 检查评估状态
        async checkEvalStatus() {
            try {
                const params = { "taskId": this.taskId };
                const res = await this.$get('/nhf-app/formulaRemoteCallback/getSupplierEvaluationProgress', params);
                if (res.success && res.data) {
                    const { status } = res.data;
                    // status == 0 或 status 为空表示评估还未开始，不显示进度弹窗
                    if (!status || status == 0) {
                        return;
                    }
                    // status == 16 表示评估已完成
                    if (status == 16) {
                        // 评估已完成，不显示进度弹窗，直接加载结果
                        this.getEvalResultData();
                        return;
                    }
                    // 其他状态表示评估正在进行中，显示进度弹窗
                    this.evalProgress = res.data.progressPer * 100 || 0;
                    if (this.evalProgress > 0) {
                        this.evalProgress = Number(this.evalProgress.toFixed(1));
                    }
                    this.totalCalculatedTimes = res.data.totalCalculatedTimes || 0;
                    this.calculatedTimes = res.data.calculatedTimes ? res.data.calculatedTimes : 0;
                    // 启动定时器继续轮询
                    this.getEvalProgress();
                }
            } catch (error) {
                // 如果获取状态失败，不做处理
            }
        },
        stopEvalTimer() {
            if (this.evalTimer) {
                clearInterval(this.evalTimer);
                this.evalTimer = null;
            }
        },
        onTempCloseEvalClick() {
            // 只关闭弹窗，保留定时器继续轮询
            this.progressModalVisible = false;
        },
        // 获取评估结果表格
        async getEvalResultData() {
            this.tableLoading = true;
            const res = await this.$post('/nhf-app/supplierevaluationresult/getSupplierEvaluationResultVOList',
                {
                    factoryId: window.localStorage.getItem('factoryId'),
                    taskId: this.taskId
                }
            );

            if (res.success) {
                // 新的数据结构是二维数组，第一行是表头
                const dataArray = res.data || [];
                if (Array.isArray(dataArray) && dataArray.length > 0) {
                    // 将所有数据转换为对象格式（包含第一行表头）
                    this.tableData = dataArray.map((item, index) => ({
                        id: index,
                        factoryName: item[0] || '',
                        rawName: item[1] || '',
                        supplierName: item[2] || '',
                        rank: item[3] !== undefined && item[3] !== '' ? item[3] : '',
                        valuePrice: item[4] !== undefined && item[4] !== '' ? item[4] : '',
                        rawPrice: item[5] !== undefined && item[5] !== null ? item[5] : 0,
                        usageAmount: item[6] !== undefined && item[6] !== null ? item[6] : 0,
                        totalCost: item[7] !== undefined && item[7] !== null ? item[7] : 0,
                        avgCost: item[8] !== undefined && item[8] !== null ? item[8] : 0,
                    }));
                } else {
                    this.tableData = [];
                }
            }
            this.tableLoading = false;
        },
        onClearBtnClick() {
            this.$confirm({
                title: '清空评估结果',
                content: '确定清空评估结果吗？',
                cancelText: '取消',
                okText: '确定',
                icon: 'info-circle',
                confirmLoading: this.clearBtnLoading,
                onOk: () => {
                    this.clearBtnLoading = true;
                    const params = { "taskId": this.taskId };
                    this.$get('/nhf-app/supplierraw/clearEvaluationResult', params).then(res => {
                        if (res.success) {
                            this.clearBtnLoading = false;
                            this.tableData = [];
                            this.$message.success('清除成功');
                        }
                    });
                },
                onCancel: () => { }
            });
        },
        onExportBtnClick() {
            let tHeader = this.tableColumns.map((item) => item.title);
            let filterVal = this.tableColumns.map((item) => item.dataIndex);
            let tTitle = `供货商评估-${new Date().getTime()}`;
            // 跳过第一行（表头数据），只导出实际数据
            const exportData = this.tableData.slice(1);
            const data = this.formatJson(filterVal, exportData);
            exportExcel(tHeader, data, tTitle);
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => {
                return v[j];
            }));
        },

        onClose() {
            // 如果评估仍在进行中，不清除定时器
            // 用户重新打开抽屉时会继续显示进度
            this.$emit('close');
        },
    }
};
</script>

<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

.section-table {
    .ant-btn {
        padding: 0 1em;
    }

    .ant-btn-primary {
        background-color: orange;
        border-color: orange;
    }

    .ant-btn-primary[disabled] {
        border-color: #d9d9d9;
        background-color: #f5f5f5;
    }
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}

::v-deep.template-import-modal {
    .step-row {
        margin-bottom: 16px;

        .ant-col-4 {
            text-align: right;

            span {
                color: #333;
            }
        }
    }

    .step-col {
        font-weight: bold;

        &::before {
            content: '*';
            color: red;
        }
    }

    /* 链接样式 */
    a:hover {
        color: #40a9ff;
    }
}

// 评估进度弹窗样式
::v-deep.eval-progress-modal {
    .ant-modal-body {
        padding: 24px;
    }
}

.eval-progress-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 160px;
}

.eval-status {
    margin-bottom: 16px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

.eval-info {
    width: 100%;
    margin: 12px 0 24px;
    font-size: 14px;
    color: #666;
    text-align: center;
    min-height: 24px;
}

.eval-loading-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.eval-progress-footer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    margin-top: 8px;
    border-top: 1px solid #f0f0f0;
}

.eval-progress-footer .ant-btn {
    min-width: 140px;
    height: 36px;
    font-size: 14px;
    border-radius: 4px;
}
</style>
